module.exports = __webpack_public_path__ + "static/media/sg8tj658.fa7c5a08.png";